import { render } from "./hr-yes-no-questions.vue?vue&type=template&id=71505288&scoped=true"
import script from "./hr-yes-no-questions.vue?vue&type=script&lang=js"
export * from "./hr-yes-no-questions.vue?vue&type=script&lang=js"

import "./hr-yes-no-questions.vue?vue&type=style&index=0&id=71505288&scoped=true&lang=css"

import exportComponent from "/home/jenkins/workspace/DeputyApp_web-hr_202604021339/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-71505288"]])

export default __exports__